import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PartialId } from '@attain-apps/string-builder'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  subscription OnAgentMessagePublished(
    $tenantId: ID!
    $zoneId: ID!
    $conversationId: ID!
  ) {
    onAgentMessagePublished(
      conversationId: $conversationId
      tenantId: $tenantId
      zoneId: $zoneId
    ) {
      id
      role
      conversationId
      createdAt
      status
      tenantId
      zoneId
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.OnAgentMessagePublishedSubscription,
    ents.core.agent.Message,
    'onAgentMessagePublished'
  >(
    'onAgentMessagePublished',
    graphql.transformers.OUT.object({
      conversationId: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        TypeChecker.isNotNullish,
        { warnOnly: true },
      ),
      createdAt: graphql.transformers.OUT.validate(
        graphql.transformers.AWS_SCALARS.datetime,
        TypeChecker.isNotNullish,
        { warnOnly: true },
      ),
      id: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        PartialId.assertIsPartialId,
      ),
      role: graphql.transformers.OUT.validate(
        graphql.transformers.OUT.enumeration<
          graphql.schema.AgentMessageRole,
          ents.core.agent.Message.Role
        >({
          [graphql.schema.AgentMessageRole.Agent]: 'agent',
          [graphql.schema.AgentMessageRole.User]: 'user',
        }),
        TypeAsserter.assertIsNotNullish,
      ),
      status: graphql.transformers.OUT.validate(
        graphql.transformers.OUT.enumeration<
          graphql.schema.AgentMessageStatus,
          ents.core.agent.Message.Status
        >({
          [graphql.schema.AgentMessageStatus.Completed]: 'completed',
          [graphql.schema.AgentMessageStatus.Failed]: 'failed',
          [graphql.schema.AgentMessageStatus.Pending]: 'pending',
        }),
        TypeAsserter.assertIsNotNullish,
      ),
    }),
  ),
)

export const executor = graphql.createSubscriber<
  graphql.schema.OnAgentMessagePublishedSubscription,
  ents.core.agent.Message,
  graphql.schema.OnAgentMessagePublishedSubscriptionVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
